<script lang="ts">
    import {onDestroy} from 'svelte'
    import {Link} from 'svelte-routing'
    import Menu from '../../../#common/menu/menu.svelte'
    import IconifyIcon from '@iconify/svelte'
    import envelopeIcon from '@iconify/icons-fa-solid/envelope'
    import twitterIcon from '@iconify/icons-fa-brands/twitter'
    import telegramIcon from '@iconify/icons-fa-brands/telegram-plane'
    import mediumIcon from '@iconify/icons-fa-brands/medium-m'
    import discordIcon from '@iconify/icons-fa-brands/discord'
    import instagramIcon from 'src/components/#assets/instagram.svg'
    import logo from 'src/components/#assets/logotype.png'
    import miniLogo from 'src/components/#assets/realis-mini.svg'
    import toTop from 'src/components/#assets/top-icon.svg'
    import menuArrow from 'src/components/#assets/menu-arrow.svg'
    import googlePlayIcon from 'src/components/#assets/google-play-icon.svg'
    import listeriaIcon from 'src/components/#assets/listeria.svg'
    import dragonsIcon from 'src/components/#assets/dragons.svg'
    import catsIcon from 'src/components/#assets/cats.svg'
    import cookie from 'src/components/#assets/cookie.svg'
    import {autoScrollTop} from 'src/components/main/#common/helpers'
    import {userProfile} from 'src/services/auth'
    import {isLoggedIn} from 'src/services/auth'
    import { link } from "svelte-routing"

    let year = new Date().getFullYear()
    let zoomLevel = Math.round(window.devicePixelRatio * 100)
    let mobileMenuOpened = false
    let url = window.location.pathname
    let widget = false
    let dropdownOpen = false

    if (typeof window !== 'undefined') {
        onDestroy(autoScrollTop({
            onPushState: true,
            onReloadPage: true,
        }))
    }

    let showToTop = false
    let lastScrollPosition = 0
    window.addEventListener('scroll', function() {
        if (window.scrollY != 0 && lastScrollPosition > window.scrollY && lastScrollPosition > 1000) {
            showToTop = true
        } else {
            showToTop = false
        }
        lastScrollPosition = window.scrollY
    })

    window.addEventListener('resize', function(){
        zoomLevel = Math.round(window.devicePixelRatio * 100)
    })

    function avatar(nickname) {
        if (nickname) {
            return nickname.slice(0, 2)
        }
    }

    function goToTop() {
        window.scrollTo(0, 0)
        showToTop = false
        widget = false
    }

    let userCookie = localStorage.getItem('userCookie')

    if (!userCookie) {
        localStorage.setItem('userCookie', 'not')
        userCookie = 'not'
    }

    function cookieAgree() {
        localStorage.setItem('userCookie', 'allow')
        userCookie = 'allow'
    }
</script>

<div class="app" class:zoom-110={zoomLevel === 110} class:zoom-125={zoomLevel === 125} class:zoom-150={zoomLevel === 150}>
    <header class="header">
        <div class="container">
            <div class="row d-flex align-items-center justify-content-space-between flex-nowrap">
<!--                <div class="col d-flex d-md-none">-->
<!--                    <button class="hamburger-btn {mobileMenuOpened ? 'active' : ''}"-->
<!--                            on:click={() => { mobileMenuOpened = !mobileMenuOpened }}>-->
<!--                        <span></span>-->
<!--                        <span></span>-->
<!--                        <span></span>-->
<!--                    </button>-->
<!--                    <Link to="/" class="logo" on:click={() => { mobileMenuOpened = false }}>-->
<!--                        <img src="{miniLogo}" class="logotype logo-mobile" alt="logo">-->
<!--                    </Link>-->
<!--                </div>-->
                <div class="col-auto">
                    <Link to="/" class="logo" on:click={() => { mobileMenuOpened = false }}>
                        <img src="{logo}" class="logotype" alt="logo">
                    </Link>
                </div>
<!--                <div class="col-auto d-flex align-items-center">-->
<!--                    <nav class="menu {mobileMenuOpened ? 'active' : ''}">-->
<!--                        <div class="menu-item {url == '/about' ? 'active' : ''}" class:open={dropdownOpen}>-->
<!--                            <div class="menu-item-dropdown-title" on:click={() => dropdownOpen = !dropdownOpen}>-->
<!--                                <span>About</span>-->
<!--                                <img src="{menuArrow}" class="menu-arrow" alt="">-->
<!--                            </div>-->
<!--                            <div class="menu-item-dropdown-list">-->
<!--                                <a href="/about" class="menu-dropdown-item" on:click={() => dropdownOpen = false} use:link><span>About us</span></a>-->
<!--                                <a href="/about#utility" class="menu-dropdown-item" on:click={() => {dropdownOpen = false; mobileMenuOpened = false}}><span>Utility</span></a>-->
<!--                                <a href="https://docs.realis.network" class="menu-dropdown-item" target="_blank" on:click={() => dropdownOpen = false}><span>Litepaper</span></a>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <Link to="games" class="menu-item {url == '/games' ? 'active' : ''}"><span>Games</span></Link>-->
<!--                        &lt;!&ndash;<Link to="marketplace" class="menu-item {url == '/marketplace' ? 'active' : ''}"><span>Marketplace</span></Link>&ndash;&gt;-->
<!--                        <Link to="support" class="menu-item {url == '/support' ? 'active' : ''}"><span>Support</span></Link>-->
<!--                        <Link to="blog" class="menu-item {url == '/blog' ? 'active' : ''}"><span>Blog</span></Link>-->
<!--                        <div class="social-links d-md-none">-->
<!--                            <a href="mailto:hello@realis.network">-->
<!--                                <IconifyIcon icon={envelopeIcon}/>-->
<!--                            </a>-->
<!--                            <a href="https://twitter.com/realisnetwork" target="_blank">-->
<!--                                <IconifyIcon icon={twitterIcon}/>-->
<!--                            </a>-->
<!--                            <a href="https://t.me/RealisANN" target="_blank">-->
<!--                                <IconifyIcon icon={telegramIcon}/>-->
<!--                            </a>-->
<!--                            <a href="https://realisnetwork.medium.com" target="_blank">-->
<!--                                <IconifyIcon icon={mediumIcon}/>-->
<!--                            </a>-->
<!--                            <a href="https://www.instagram.com/realis.network/" target="_blank">-->
<!--                                <img src={instagramIcon} class="instagram-icon" alt="">-->
<!--                            </a>-->
<!--                            <a href="https://discord.gg/realis" target="_blank">-->
<!--                                <IconifyIcon icon={discordIcon}/>-->
<!--                            </a>-->
<!--                        </div>-->
<!--                    </nav>-->
<!--                </div>-->
                <div class="col d-none d-sm-block"></div>
                <div class="col-auto d-flex align-items-center">
                    {#if $isLoggedIn}
<!--                        <Link to="wallet" on:click={() => { mobileMenuOpened = false }} class="d-none d-lg-block btn-primary account-btn">-->
<!--                            <div class="account-text">Account</div>-->
<!--                        </Link>-->
                    {:else}
<!--                        <Link to="login" on:click={() => { mobileMenuOpened = false }} class="menu-item login-btn {url == '/login' ? 'active' : ''}">Log in</Link>-->
<!--                        <Link to="register" on:click={() => { mobileMenuOpened = false }} class="btn btn-primary register-btn">Sign up</Link>-->
                    {/if}
                </div>
            </div>
        </div>
    </header>
    {#if $isLoggedIn}
        <Menu template="main"/>
    {/if}

    <slot name="content" />

    <footer class="footer">
        <div class="container">
            <div class="row">
                <div class="col-md-4">
                    <Link to="/" class="logo">
                        <img src="{logo}" class="footer-logotype" alt="logo">
                    </Link>
                </div>
                <div class="col-md-8">
                    <nav class="menu">
<!--                        <Link to="about" class="menu-item">About</Link>-->
<!--                        <Link to="games" class="menu-item">Games</Link>-->
                        <!--<Link to="marketplace" class="menu-item">Marketplace</Link>-->
<!--                        <Link to="support" class="menu-item">Support</Link>-->
<!--                        <Link to="blog" class="menu-item">Blog</Link>-->
                    </nav>
                    <div class="social-links">
<!--                        <a href="https://t.me/RealisANN" target="_blank">-->
<!--                            <IconifyIcon icon={telegramIcon}/>-->
<!--                        </a>-->
<!--                        <a href="https://twitter.com/realisnetwork" target="_blank">-->
<!--                            <IconifyIcon icon={twitterIcon}/>-->
<!--                        </a>-->
<!--                        <a href="https://discord.gg/realis" target="_blank">-->
<!--                            <IconifyIcon icon={discordIcon}/>-->
<!--                        </a>-->
<!--                        <a href="https://realisnetwork.medium.com" target="_blank">-->
<!--                            <IconifyIcon icon={mediumIcon}/>-->
<!--                        </a>-->
<!--                        <a href="https://www.instagram.com/realis.network/" target="_blank">-->
<!--                            <img src={instagramIcon} class="instagram-icon" alt="">-->
<!--                        </a>-->
<!--                        <a href="mailto:support@realis.network">-->
<!--                            <IconifyIcon icon={envelopeIcon}/>-->
<!--                        </a>-->
                    </div>
                </div>
            </div>
            <hr>
            <div class="row d-mobile-reverse">
                <div class="col-md-6">
                    <div class="copyright">Elemental Games Pte. Ltd. <br>&copy; All Rights Reserved { year }. <br>68 Circular Road, #02-01, 049422, Singapore</div>
                </div>
                <div class="col-md-6">
                    <div class="text-right">
                        <div class="after-footer-links">
                            <Link to="policy" class="footer-link">Privacy Policy</Link>
                            <Link to="terms" class="footer-link">Terms of Use</Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
    <div class="to-top" on:click={goToTop} class:visible={showToTop}>
        <img src="{toTop}" alt="">
    </div>
<!--    <div class="games-widget">-->
<!--        <div class="widget-content" class:active={widget}>-->
<!--            <a href="https://play.google.com/store/apps/details?id=com.game.moba.realis.battle.royale" target="_blank" class="game-app-icon">-->
<!--                <img src="{listeriaIcon}" alt="">-->
<!--                <div>Legends<br>Of Listeria</div>-->
<!--            </a>-->
<!--            <a href="https://play.google.com/store/apps/details?id=com.dragons.tokens.crypto" target="_blank" class="game-app-icon">-->
<!--                <img src="{dragonsIcon}" alt="">-->
<!--                <div>Crypto<br>Dragons</div>-->
<!--            </a>-->
<!--            <a href="https://play.google.com/store/apps/details?id=com.soul.merge.cat.cute.simulator.adventure" target="_blank" class="game-app-icon">-->
<!--                <img src="{catsIcon}" alt="">-->
<!--                <div>Crypto<br>Cats</div>-->
<!--            </a>-->
<!--        </div>-->
<!--        <div class="widget-icon" on:click={() => {widget = !widget}}>-->
<!--            <img src="{googlePlayIcon}" alt="">-->
<!--        </div>-->
<!--    </div>-->
    <div class="cookie-window" class:d-none={userCookie && userCookie == 'allow'}>
        <div class="container">
            <div class="cookie-icon">
                <img src="{cookie}" alt="">
            </div>
            <div class="cookie-text">
                We use cookies to improve user experience. You can read more about our Cookie Policy in our
                <Link to="policy">Privacy policy</Link>
            </div>
            <div class="cookie-button">
                <button class="btn btn-primary" on:click={cookieAgree}>
                    Yes, I agree
                </button>
            </div>
        </div>
    </div>
</div>

<style lang="postcss">
    .app.zoom-110 {
        zoom: 0.91;
    }

    .app.zoom-125 {
        zoom: 0.8;
    }

    .app.zoom-150 {
        zoom: 0.67;
    }

    .header {
        background: rgba(1, 7, 10, 0.7);
        position: fixed;
        width: 100%;
        height: 110px;
        backdrop-filter: blur(10px);
        border-bottom: 2px solid #282D39;
        top: 0;
        left: 0;
        z-index: 7;
        right: 0;
        display: flex;
        align-items: center;
    }

    .header .menu {
        margin-left: 90px;
    }

    .instagram-icon {
        width: 20px;
    }

    .header :global(.menu-item) {
        font-size: 18px;
        line-height: 22px;
        color: white;
        font-weight: 500;
        text-decoration: none;
        margin-right: 50px;
        padding: 44px 0;
        position: relative;
        display: inline-block;
        text-transform: uppercase;
        transition: .25s;
    }

    .header :global(.menu-item .menu-item-dropdown-title) {
        color: white;
        text-decoration: none;
        transition: .25s;
        cursor: pointer;
        user-select: none;
    }

    .header :global(.menu-item.active:after) {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        background: linear-gradient(180deg, rgba(255, 93, 28, 0) 0%, rgba(255, 93, 28, 0.3) 100%);
        width: 100%;
        height: 50%;
        border-bottom: 2px solid #3cdbc0;
        z-index: -1;
    }

    .header :global(.menu-item.login-btn) {
        font-weight: 500;
        margin-right: 30px;
    }

    .header :global(.menu-item:hover) {
        color: #dfdfdf;
    }

    .header :global(.menu-item .menu-item-dropdown-title:hover) {
        color: #dfdfdf;
    }

    .header :global(.btn-secondary) {
        margin-right: 8px;
    }

    .header :global(.btn-primary.account-btn),
    .header :global(.btn-primary.register-btn) {
        padding: 14px 20px;
        font-size: 18px;
        line-height: 22px;
        font-weight: 500;
        text-transform: uppercase;
    }

    .menu-item-dropdown-list {
        position: absolute;
        display: none;
        background: #282D39;
        box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
        border-radius: 3px;
        padding: 15px 20px;
        margin-top: 10px;
        min-width: 180px;
        border: 1px solid #91A2FA;
    }

    .menu-dropdown-item {
        font-size: 16px;
        color: #A0AEC0;
        display: table;
        font-weight: 300;
        text-decoration: none;
        white-space: nowrap;
        transition: .25s;
        text-transform: none;
    }

    .menu-dropdown-item + .menu-dropdown-item {
        margin-top: 18px;
    }

    .header :global(.menu-item .menu-item-dropdown-title .menu-arrow) {
        margin: 7px 0 0 10px;
        vertical-align: top;
        transform: rotate(180deg);
        transition: .25s;
    }

    .header :global(.menu-item.open .menu-item-dropdown-title .menu-arrow) {
        transform: rotate(0);
    }

    .header :global(.menu-item.open .menu-item-dropdown-list) {
        display: block;
    }

    .menu-dropdown-item:hover {
        color: white;
    }

    .logotype {
        display: block;
        width: 130px;
    }

    .footer {
        border-top: 2px solid #282D39;
        padding: 60px 0 40px;
    }

    .footer-logotype {
        width: 180px;
    }

    .footer .menu {
        text-align: right;
        margin-bottom: 50px;
    }

    .footer hr {
        background: #282D39;
        height: 2px;
        opacity: 1;
        margin: 60px 0 40px;
    }

    .footer :global(.menu-item) {
        font-size: 18px;
        line-height: 22px;
        color: #808384;
        text-decoration: none;
        transition: .25s;
    }

    .social-links {
        text-align: right;
    }

    .footer :global(.menu-item:not(:last-child)) {
        margin-right: 100px;
    }

    .footer :global(.menu-item:hover) {
        color: #dfdfdf;
    }

    .footer-link {
        font-size: 14px;
        color: white;
        text-decoration: none;
        margin-left: 30px;
    }

    .footer-link:first-child {
        margin-left: 0;
    }

    .footer-link:hover {
        color: white;
        text-decoration: underline;
    }

    .copyright {
        font-size: 14px;
        color: #BDBDBD;
    }

    .after-footer-links {
        text-align: right;
    }

    .social-links a {
        color: white;
        font-size: 20px;
        display: inline-block;
        margin-left: 50px;
        line-height: 20px;
        vertical-align: top;
        opacity: 0.7;
        transition: .25s;
    }

    .social-links a:hover {
        opacity: 1;
    }

    .social-links a:first-child {
        margin-left: 0;
    }

    .footer :global(.footer-link) {
        font-size: 14px;
        color: #BDBDBD;
        text-decoration: none;
        transition: .25s;
    }

    .footer :global(.footer-link:not(:last-child)) {
        margin-right: 26px;
    }

    .footer :global(.footer-link:hover) {
        color: white;
    }

    .app {
        font-size: 18px;
        line-height: 18.16px;
        color: #1e1e1e;
        font-weight: 400;
        background: #01070A;
        font-family: 'Inter', sans-serif;
        letter-spacing: 1px;

        :global {
            @import 'src/styles/app.pcss';
        }
    }

    .hamburger-btn {
        width: 40px;
        height: 40px;
        border: 0;
        margin-right: 20px;
        padding: 11px;
        border-radius: 3px;
        background: #282D39;
    }

    .hamburger-btn span:first-child {
        margin-top: 0;
    }

    .hamburger-btn span:last-child {
        margin-bottom: 0;
    }

    .hamburger-btn span {
        height: 2px;
        background: white;
        width: 18px;
        margin: 4px 0;
        display: block;
        border-radius: 2px;
        transition: .25s;
    }

    .hamburger-btn span:nth-child(3) {
        width: 9px;
    }

    .hamburger-btn.active span:nth-child(1) {
        transform: rotate(45deg) translate(4px, 4px);
    }

    .hamburger-btn.active span:nth-child(2) {
        opacity: 0;
    }

    .hamburger-btn.active span:nth-child(3) {
        transform: rotate(-45deg) translate(4px, -4px);
        width: 18px;
    }

    .to-top {
        visibility: hidden;
        position: fixed;
        bottom: 90px;
        right: 90px;
        width: 70px;
        height: 70px;
        border: 1px solid white;
        border-radius: 50%;
        cursor: pointer;
        z-index: 10;
        opacity: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: .25s;
    }

    .to-top:hover {
        background: white;
    }

    .to-top:hover img {
        filter: brightness(0);
    }

    .to-top.visible {
        opacity: 1;
        visibility: visible;
    }

    .logo-mobile {
        display: none;
    }

    .header :global(.avatar) {
        display: none;
    }

    .games-widget {
        display: none;
    }

    .cookie-window {
        position: fixed;
        width: 100%;
        bottom: 0;
        left: 0;
        z-index: 10;
        background: #1F1D36;
        padding: 10px 0;
        backdrop-filter: blur(300px);
        box-shadow: 0 0 10px rgba(255, 255, 255, 0.15);
    }

    .cookie-window .container {
        display: flex;
        align-items: center;
    }

    .cookie-text {
        font-size: 13px;
        line-height: 22px;
        color: white;
        margin: 0 150px 0 30px;
        width: 100%;
    }

    .cookie-text :global(a) {
        color: white;
    }

    .cookie-button :global(.btn-primary) {
        text-transform: uppercase;
        white-space: nowrap;
    }

    @media(max-width: 1400px) {
        .header .menu {
            margin-left: 40px;
        }

        .footer :global(.menu-item:not(:last-child)) {
            margin-right: 60px;
        }

        .to-top {
            right: 40px;
        }
    }

    @media(max-width: 1199px) {
        .header .menu {
            margin-left: 20px;
        }

        .header :global(.menu-item) {
            font-size: 16px;
            margin-right: 18px;
        }

        .footer-logotype {
            width: 150px;
        }

        .footer :global(.menu-item:not(:last-child)) {
            margin-right: 20px;
        }
    }

    @media(max-width: 991px) {
        .header .menu {
            margin-left: 0;
        }

        .menu-item-dropdown-list {
            min-width: 150px;
        }

        .header :global(.menu-item) {
            font-size: 14px;
            line-height: 15px;
        }

        .header :global(.menu-item .menu-item-dropdown-title .menu-arrow) {
            margin: 4px 0 0 5px;
        }

        .menu-dropdown-item {
            font-size: 14px;
        }

        .header :global(.menu-item:not(:last-child)) {
            margin-right: 10px;
        }

        .logotype {
            width: 110px;
        }

        .header :global(.btn-primary.register-btn) {
            padding: 10px;
            font-size: 14px;
            line-height: 18px;
        }

        .header :global(.btn-primary.account-btn) {
            display: none;
        }

        .footer :global(.menu-item) {
            font-size: 16px;
        }

        .to-top {
            bottom: 60px;
            right: 50px;
            width: 50px;
            height: 50px;
        }

        .cookie-text {
            margin: 0 15px;
            width: 100%;
        }

        .cookie-icon img {
            width: 60px;
        }
    }

    @media(max-width: 767px) {
        .header {
            height: 62px;
            background: #01070A;
            z-index: 10;
        }

        .header :global(.menu-item) {
            display: block;
            width: 100%;
            border-bottom: 2px solid #A0AEC0;
            position: relative;
            transition: .25s;
            font-size: 36px;
            text-align: left;
            font-weight: 600;
            padding: 20px 12px;
            line-height: normal;
        }

        .header :global(.menu-item.login-btn) {
            font-size: 14px;
            padding: 23px 5px;
            border-bottom: 0;
        }

        .header :global(.btn-primary.account-btn),
        .header :global(.btn-primary.register-btn) {
            padding: 10px 10px;
            font-size: 14px;
            white-space: nowrap;
            margin-left: 10px;
        }

        .logo-pc {
            display: none;
        }

        .logo-mobile {
            display: block;
            width: 40px;
            height: 40px;
        }

        .footer {
            margin: 40px 0 0;
            padding-bottom: 30px;
        }

        .footer-link {
            font-size: 13px;
            margin: 24px auto;
            display: block;
            text-align: center;
        }

        .copyright {
            font-size: 14px;
            text-align: center;
        }

        .header-menu a {
            display: block;
            color: #1c1d21;
            font-size: 20px;
            padding: 0;
            margin: 20px 0;
            text-align: center;
            font-weight: 500;
        }

        .header .menu {
            display: none;
            background: linear-gradient(272deg, #14141E 0%, #2A1D27 71%);
        }

        .footer :global(.menu-item) {
            font-size: 14px;
            color: #808384;
            line-height: normal;
        }

        .footer :global(.menu-item:not(:last-child)) {
            margin-right: 10px;
        }

        .footer :global(.footer-link:not(:last-child)) {
            margin-right: 20px;
        }

        .footer :global(.footer-link) {
            font-size: 14px;
            line-height: normal;
            margin: 0;
            display: inline-block;
        }

        .footer .menu {
            width: 100%;
            text-align: center;
            margin: 50px 0 15px;
        }

        .social-links {
            margin: 50px 0 0;
            display: flex;
            justify-content: center;
        }

        .menu .social-links {
            margin: 50px 12px 0;
        }

        .social-links a {
            font-size: 20px;
            margin: 0 12px;
        }

        .header .menu.active {
            display: block;
            position: absolute;
            top: 62px;
            left: 0;
            margin: 0;
            width: 100%;
            height: calc(100vh - 62px);
            overflow: auto;
            padding-top: 1px;
        }

        .header :global(.menu-item:not(:last-child)) {
            margin-right: 0;
        }

        .header :global(.menu-item:last-child) {
            border-bottom: 0;
        }

        .header :global(.menu-item:before) {
            content: "";
            border-top: 1px solid transparent;
            position: absolute;
            width: 100%;
            left: 0;
            top: -1px;
            transition: .25s;
        }

        .header :global(.menu-item:after) {
            content: "";
            border-bottom: 1px solid transparent;
            position: absolute;
            width: 100%;
            left: 0;
            bottom: -1px;
            transition: .25s;
        }

        .header :global(.menu-item:hover) {
            color: #3cdbc0;
        }

        .header .menu .social-links {
            margin-top: 30px;
            text-align: center;
        }

        .footer-logotype {
            width: 200px;
            margin: 0 auto;
            display: block;
        }

        .footer hr {
            margin: 30px 0;
        }

        .after-footer-links {
            text-align: center;
            margin-bottom: 30px;
        }

        .d-mobile-reverse {
            flex-direction: column-reverse;
        }

        .account-text {
            display: none;
        }

        .header :global(.avatar) {
            display: flex;
            width: 40px;
            height: 40px;
            background: #282d39;
            justify-content: center;
            align-items: center;
            border-radius: 50%;
            font-size: 22px;
            font-family: 'Anton', sans-serif;
            color: white;
            text-transform: uppercase;
            text-decoration: none;
        }

        .to-top {
            right: 15px;
            bottom: 20px;
            width: 70px;
            height: 70px;
        }

        .to-top.visible {
            background: #01070a;
        }

        .to-top.visible:hover {
            background: white;
        }

        .games-widget {
            position: fixed;
            display: block;
            right: 15px;
            bottom: 20px;
            z-index: 9;
        }

        .widget-content {
            background: #282D39;
            width: 100%;
            height: 70px;
            position: absolute;
            bottom: 0;
            padding-top: 10px;
            border-radius: 70px;
            visibility: hidden;
            opacity: 0;
            transition: .25s;
        }

        .widget-content.active {
            height: 352px;
            box-shadow: 0 0 7px rgba(255, 255, 255, 0.1);
            opacity: 1;
            visibility: visible;
        }

        .widget-icon {
            width: 70px;
            height: 70px;
            background: #A0AEC0;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            padding-left: 8px;
            position: relative;
        }

        .game-app-icon {
            margin: 0 0 12px;
            text-align: center;
            display: block;
            color: white;
            text-decoration: none;
            opacity: 0;
            transition: .35s;
        }

        .widget-content.active .game-app-icon {
            opacity: 1;
        }

        .game-app-icon div {
            font-size: 10px;
            line-height: 13px;
            font-weight: 300;
            margin-top: 3px;
        }

        .cookie-window .container {
            flex-wrap: wrap;
        }

        .cookie-window {
            padding: 15px 8px 20px;
        }

        .cookie-button :global(.btn-primary) {
            width: 100%;
        }

        .cookie-text {
            margin: 10px 0 20px;
        }

        .cookie-icon img {
            width: 50px;
        }

        .cookie-button {
            width: 100%;
        }

        .header :global(.menu-item .menu-item-dropdown-title .menu-arrow) {
            margin: 13px 0 0 10px;
            width: 25px;
            transform: rotate(90deg);
        }

        .header :global(.menu-item.open .menu-item-dropdown-title .menu-arrow) {
            transform: rotate(180deg);
        }

        .menu-item-dropdown-list {
            position: relative;
            background: none;
            border-radius: 0;
            padding: 10px;
            box-shadow: none;
            border: 0;
        }

        .menu-dropdown-item {
            font-size: 30px;
            color: #A0AEC0;
            text-transform: uppercase;
            border-bottom: 2px solid transparent;
        }

        .menu-dropdown-item + .menu-dropdown-item {
            margin-top: 28px;
        }

        .menu-dropdown-item:hover {
            color: #3cdbc0;
        }

        .header :global(.menu-item .menu-item-dropdown-title:hover) {
            color: white;
        }
    }
</style>
